const JOURS = [
  'Lun.',
  'Mar.',
  'Mer.',
  'Jeu.',
  'Ven.',
  'Sam.',
  'Dim.'
]
const JOURS2 = [
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi',
  'Dimanche'
]

export const capitalize = (value) => {
  if (value) {
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  }
}

export const formatDate = (value) => {
  if (value) {
    return moment(value, 'DD-MM-YYYY').format('DD/MM/YYYY')
  }
}

export const getHumanDate = function (date) {
  return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
}

export const formatDateTime = (value) => {
  if (value) {
    moment.locale('fr')
    return moment(value, 'DD-MM-YYYY HH-mm-ss').format('DD/MM/YYYY à HH:mm')
  }
}

export const formatDateFull = (value) => {
  if (value) {
    const fullDate = moment(value, 'DD-MM-YYYY HH:mm:ss')
    let dayIndex = fullDate.day() - 1
    if (dayIndex < 0) {
      dayIndex += 7
    }
    const day = JOURS[dayIndex]
    const date = fullDate.format('DD/MM/YYYY')
    const time = fullDate.format('HH:mm')
    return `${day}<br>${date}<br>${time}`
  }
}

export const formatDateStr = (value) => {
  if (value) {
    var date = new Date(value)
    return moment(date).format('DD/MM/YYYY')
  }
}

export const formatPrice = (value) => {
  return parseFloat(value).toLocaleString('fr', {maximumFractionDigits: 0})
}

export const formatDecimalPrice = (value) => {
  var expectedValue = parseFloat(value).toLocaleString('fr', {maximumFractionDigits: 2})
  if (expectedValue.toString().includes(',')) {
      return expectedValue
  }
  return expectedValue + ',00'
}

export const formatDepartment = (value) => {
  return value.substring(0,2)
}